import { useConfig as hook, BaseConfig } from '@eika-infrastruktur/config-provider';

import { nbTranslations, nnTranslations, TranslationsConfigType } from './translations';

interface Link {
    target?: string;
    text?: string;
    url: string;
}

export interface Config extends BaseConfig {
    links: {
        redirectURL: Link;
        kjoepeBolig: Link;
        finansieringsbevis: Link;
        flytteBoliglaan: Link;
        okeBoliglaan: Link;
        byggelaan: Link;
    };
    siteLang: 'nb' | 'nn';
    translations: {
        nb: TranslationsConfigType;
        nn: TranslationsConfigType;
    };
    featureToggles: {
        aktivsamarbeid: boolean;
        disableByggelaan: boolean;
        disableKjoepeBolig: boolean;
    };
}

export const defaultConfig: Config = {
    links: {
        redirectURL: {
            url: 'https://www.eika.no',
        },
        kjoepeBolig: {
            url: `${window.location.origin}/min-oversikt/kjopebolig`,
        },
        finansieringsbevis: {
            url: `${window.location.origin}/min-oversikt/finbevis`,
        },
        flytteBoliglaan: {
            url: `${window.location.origin}/min-oversikt/flytteboliglaan`,
        },
        okeBoliglaan: {
            url: `${window.location.origin}/min-oversikt/refinansiere`,
        },
        byggelaan: {
            url: `${window.location.origin}/kontaktskjema-privat?product=byggelan`,
        },
    },
    siteLang: 'nb' as const,
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
    featureToggles: {
        aktivsamarbeid: false,
        disableByggelaan: false,
        disableKjoepeBolig: false,
    },
};

function createHook<T>(): () => T {
    return () => hook<T>();
}

export const useConfig = createHook<typeof defaultConfig>();
